// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"19d48782","453":"9db46b06","667":"a0da76c1","946":"eaeb076b"}[chunkId] + ".chunk.js";
};